/*
 * @Description: 首页应用位骨架
 * @Author: 蔺晨
 * @Date: 2020-12-11
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Shape from './Shape';
import { Flex } from 'antd-mobile';

export default class NewsFrame extends Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <Flex align="center" style={{ padding: '0 28px' }}>
        <Shape type="square" w="128px" h="40px" />
        <Flex.Item>
          <Shape type="square" w="100%" h="20px" margin="16px 0 0 0" />
        </Flex.Item>
      </Flex>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pubBiz/FrameWork/NewsFrame.js